module.exports = __webpack_public_path__ + "static/media/ic-bluetooth.8cd61558.svg";